// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAccountRequest } from './IAccountRequest';
import {
    IAccountRequestFromJSON,
    IAccountRequestFromJSONTyped,
    IAccountRequestToJSON,
    IAccountRequestToJSONTyped,
} from './IAccountRequest';
import type { IReferenceToken } from './IReferenceToken';
import {
    IReferenceTokenFromJSON,
    IReferenceTokenFromJSONTyped,
    IReferenceTokenToJSON,
    IReferenceTokenToJSONTyped,
} from './IReferenceToken';

/**
 * 
 * @export
 * @interface ITokenizeAccountRequest
 */
export interface ITokenizeAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof ITokenizeAccountRequest
     */
    fd_customer_id: string;
    /**
     * 
     * @type {IReferenceToken}
     * @memberof ITokenizeAccountRequest
     */
    token: IReferenceToken;
    /**
     * 
     * @type {IAccountRequest}
     * @memberof ITokenizeAccountRequest
     */
    account: IAccountRequest;
}

/**
 * Check if a given object implements the ITokenizeAccountRequest interface.
 */
export function instanceOfITokenizeAccountRequest(value: object): value is ITokenizeAccountRequest {
    if (!('fd_customer_id' in value) || value['fd_customer_id'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('account' in value) || value['account'] === undefined) return false;
    return true;
}

export function ITokenizeAccountRequestFromJSON(json: any): ITokenizeAccountRequest {
    return ITokenizeAccountRequestFromJSONTyped(json, false);
}

export function ITokenizeAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITokenizeAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fd_customer_id': json['fdCustomerId'],
        'token': IReferenceTokenFromJSON(json['token']),
        'account': IAccountRequestFromJSON(json['account']),
    };
}

export function ITokenizeAccountRequestToJSON(json: any): ITokenizeAccountRequest {
    return ITokenizeAccountRequestToJSONTyped(json, false);
}

export function ITokenizeAccountRequestToJSONTyped(value?: ITokenizeAccountRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fdCustomerId': value['fd_customer_id'],
        'token': IReferenceTokenToJSON(value['token']),
        'account': IAccountRequestToJSON(value['account']),
    };
}

